/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, useEffect, useRef, useState } from 'react';
import { Form, Button, Table, Modal } from 'react-bootstrap';
import { KTIcon } from '../../../../../_theme/helpers/components/KTIcon';
import SimpleLoader from '../../../apps/components/SimpleLoader';
import { useFormikContext, ErrorMessage } from 'formik';
import CustomFormInput from '../../../apps/components/CustomFormInput';
import DeleteConfirmationModal from '../../../apps/components/DeleteConfirmationModal';
import {  TimelineTableArea } from '../../../core/_models';

type Props = {
  timeline_table_areas: TimelineTableArea[];
  submitLoader: boolean;
  disableFormFields: boolean;
};

const TimelineTable: FC<Props> = ({ timeline_table_areas, submitLoader, disableFormFields }) => {
  const rows: TimelineTableArea[] = timeline_table_areas;

  const { setFieldValue } = useFormikContext();

  const [loading, setLoading] = useState<boolean>(false);
  const triggerButtonRef = useRef<HTMLButtonElement | null>(null);

  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState<'add' | 'edit'>('add');
  const [editingIndex, setEditingIndex] = useState<number | null>(null);

  const [formData, setFormData] = useState<TimelineTableArea>({
    title: '',
    description: ''
  });

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedData, setSelectedData] = useState<number | null>(null);

  useEffect(() => {
    // No lookups to fetch anymore
    setLoading(false);
  }, []);

  const openAddModal = () => {
    setFormData({
      title: '',
      description: '',
    });

    setModalMode('add');
    setShowModal(true);
  };

  const openEditModal = (index: number) => {
    setFormData(rows[index]);
    setEditingIndex(index);
    setModalMode('edit');
    setShowModal(true);
  };

  const handleSave = async () => {
    const insertFormData = { ...formData };

    if (modalMode === 'add') {
      setFieldValue('timeline.timeline_table_areas', [...rows, insertFormData]);
    } else if (modalMode === 'edit' && editingIndex !== null) {
      const updatedRows = [...rows];
      updatedRows[editingIndex] = insertFormData;
      setFieldValue('timeline.timeline_table_areas', updatedRows);
    }

    setShowModal(false);
    setEditingIndex(null);
  };

  const handleDelete = (index: number) => {
    setSelectedData(index);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = () => {
  let updatedRows = [...rows];

  if (selectedData !== null) {
    // just remove row from array
    updatedRows = updatedRows.filter((_, i) => i !== selectedData);
  }

  setFieldValue('timeline.timeline_table_areas', updatedRows);
  setShowDeleteModal(false);
  setSelectedData(null);
};


  let visibleRowCount = 0;

  return (
    <div className='w-100 position-relative'>
      {(loading || submitLoader) && <SimpleLoader />}

      {!disableFormFields && (
        <div className='mb-4 text-end'>
          <Button
            ref={triggerButtonRef}
            variant='light-primary'
            size='sm'
            onClick={openAddModal}
          >
            Add
          </Button>
        </div>
      )}

      <Table
        bordered
        hover
        responsive
        className='table table-bordered border-secondary w-100'
      >
        <thead>
          <tr className='bg-secondary align-middle'>
            <th className='text-gray-700'>#</th>
            <th className='text-gray-700'>Timeline</th>
            <th className='text-gray-700'>Description</th>
            {!disableFormFields && (
              <th
                style={{ width: '120px' }}
                className='text-center text-gray-700'
              >
                Action
              </th>
            )}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan={4} className='text-center'>
                No data added yet.
              </td>
            </tr>
          ) : (
            rows.map((row: TimelineTableArea, idx: number) => {
              visibleRowCount++;
              return (
                <tr key={idx}>
                  <td>{visibleRowCount}</td>
                  <td>{row.title}</td>
                  <td>{row.description}</td>
                  {!disableFormFields && (
                    <td className='text-center'>
                      <Button
                        variant='light-info'
                        size='sm'
                        className='me-2'
                        onClick={() => openEditModal(idx)}
                        title='Edit'
                      >
                        <KTIcon iconName='pencil' className='fs-3 pe-0' />
                      </Button>
                      <Button
                        variant='light-danger'
                        size='sm'
                        onClick={() => handleDelete(idx)}
                        title='Delete'
                      >
                        <KTIcon iconName='trash' className='fs-3 pe-0' />
                      </Button>
                    </td>
                  )}
                </tr>
              );
            })
          )}
        </tbody>
      </Table>

      <div className='text-danger mt-2'>
        <ErrorMessage name='timeline.timeline_table_areas' />
      </div>

      {/* Add/Edit Modal */}
      <Modal
        id='timeline_table_kt_modal_create_app'
        tabIndex={-1}
        aria-hidden='true'
        dialogClassName='modal-dialog modal-dialog-centered mw-900px'
        show={showModal}
        onHide={() => {
          setShowModal(false);
          triggerButtonRef.current?.focus();
        }}
        backdrop="static" keyboard={false}
      >
        <div className='modal-header'>
          <h2>{modalMode === 'add' ? 'Add' : 'Edit'} Timeline</h2>
          <div
            className='btn btn-sm btn-icon btn-active-color-primary'
            onClick={() => setShowModal(false)}
          >
            <KTIcon className='fs-1' iconName='cross' />
          </div>
        </div>
        <div className='modal-body py-lg-10 px-lg-10'>
          <div className='row'>
            <div className='col-md-6'>
              <Form.Group className='mb-3'>
                <Form.Label>Timeline</Form.Label>
                <CustomFormInput
                  type='input'
                  value={formData.title}
                  onChange={(e) =>
                    setFormData({ ...formData, title: e.target.value })
                  }
                  placeholder='Enter Timeline'
                  disabled={disableFormFields}
                />
              </Form.Group>
            </div>
            <div className='col-md-6'>
              <Form.Group>
                <Form.Label>Description</Form.Label>
                <CustomFormInput
                  type='input'
                  value={formData.description ?? ''}
                  onChange={(e) =>
                    setFormData({ ...formData, description: e.target.value })
                  }
                  placeholder='Enter Description'
                  disabled={disableFormFields}
                />
              </Form.Group>
            </div>
          </div>
        </div>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button
            variant='primary'
            onClick={handleSave}
            disabled={!formData.title || !formData.description}
          >
            {modalMode === 'add' ? 'Add' : 'Update'}
          </Button>
        </Modal.Footer>
      </Modal>

      <DeleteConfirmationModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleConfirmDelete}
        deleteMessage={`Are you sure you want to delete this Timeline ?`}
      />
    </div>
  );
};

export { TimelineTable };